"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_dashboard__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b74b85b0-2aac-467f-911b-9a5040b777db",
    x1: 112.74,
    y1: 78.36,
    x2: 169.76,
    y2: 135.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "5a55e5ab-eca4-41c5-b591-005d41632e16",
    "data-name": "Dashboard_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174A80,80,0,0,1,16,95c0,.33,0,.66,0,1a80,80,0,1,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("line", {
    id: "a8c6e686-83da-4c27-9d46-320f1b9e8fc9",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 35.54,
    x2: 96,
    y2: 52.54,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "6415b252-c2f0-4654-92cd-a0ff298a0cb9",
    "data-name": "<Pfad>",
    x1: 52.37,
    y1: 96,
    x2: 35.37,
    y2: 96,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "eff98fb5-3697-441f-bc90-fe8b99a57a25",
    "data-name": "<Pfad>",
    x1: 139.37,
    y1: 95.98,
    x2: 156.37,
    y2: 95.98,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "b5e0628d-9233-46e4-a66b-76ba8cb291f4",
    "data-name": "<Pfad>",
    x1: 65.11,
    y1: 65.28,
    x2: 53.09,
    y2: 53.26,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,80A16,16,0,1,1,80,96,16,16,0,0,1,96,80m0-2a18,18,0,1,0,18,18A18,18,0,0,0,96,78Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,104,144,160a79.87,79.87,0,0,0,32-64c0-2-.1-4-.24-5.91l-37.38-37Z",
    opacity: 0.2,
    fill: "url(#b74b85b0-2aac-467f-911b-9a5040b777db)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 12,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("line", {
    id: "f48b6904-30fb-44c0-9b79-373fbd45de5a",
    "data-name": "<Pfad>",
    x1: 104.73,
    y1: 87.77,
    x2: 136,
    y2: 56.5,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,57.48,107.71,88.75a4.22,4.22,0,0,1-.67.54,12,12,0,0,1,.53,1.57l.14-.11L139,59.48a4.19,4.19,0,0,0,1.1-4A4.17,4.17,0,0,1,139,57.48Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,106A12,12,0,0,1,84.05,95c0,.33-.05.66-.05,1a12,12,0,1,0,24,0c0-.34,0-.66-.05-1A12,12,0,0,1,96,106Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "dashboard-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "e3bf6155-4acd-4fc1-ac2e-dc53fd043abf",
    "data-name": "Speedchecker_Dashboard_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "f63f2db2-a883-42ae-ac50-a2ad8688df1b",
    "data-name": "Dashboard_ic_hi",
    width: 192,
    height: 192,
    xlinkHref: "#5a55e5ab-eca4-41c5-b591-005d41632e16"
  })));
}

var _default = ic_dashboard__dark;
exports.default = _default;